import styled from "styled-components";
import NarrowGrid from "../../../../components/NarrowGrid";
import PrimaryButton from "../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../components/FormControls/SecondaryButton";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import request from "../../../../api/request";
import NotificationManager from "react-notifications/lib/NotificationManager";
import MessageBox from "../../../../components/MessageBox";

const StyledMessageLeftPane = styled.div`
	background-color: white;
	width: 632px;
	min-height: 520px;
    box-sizing: border-box;
	height: 100%;
	padding: 30px;
`;

function MessageLeftPane(props) {

    const navigate = useNavigate();

	const {gridColumns, gridData, gridStyle, messageIdToSelect, selectedMessage, onSelectGridItem, isAddMode, setIsAddMode, refreshMessagesCallback} = props;

    const [showMessageBox, setShowMessageBox] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

	const handleClickCreateNewMessage = () => {
		if (setIsAddMode) {
			setIsAddMode(true);
			navigate('/admin/messages/main');
		}
	}

    const deleteExpiredMessages = async () => {
        setShowMessageBox(false);

        setIsDeleting(true);
        const resp = (await request('database', 'deleteExpiredMessages'));
        if (resp.ok && refreshMessagesCallback) {
            NotificationManager.success('Expired messages are deleted');
            refreshMessagesCallback();
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDeleting(false);
    }

    return (
        <StyledMessageLeftPane>
			<NarrowGrid id='messages_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddMode} itemIdToSelect={messageIdToSelect} onSelectGridItem={onSelectGridItem} gridStyle={gridStyle}></NarrowGrid>
            <div style={{marginTop:20}}>
                {!isAddMode && <SecondaryButton caption='Delete expired messages' isLoading={isDeleting} onClick={() => setShowMessageBox(true)} style={{width:160, height:25}}></SecondaryButton>}
                {!isAddMode && <PrimaryButton caption='Create new message' onClick={() => handleClickCreateNewMessage()} style={{width:140, height:25, float:'right'}}></PrimaryButton>}
                {isAddMode && <SecondaryButton caption='Cancel' onClick={() => setShowMessageBox(true)} style={{width:100, height:25, float:'right'}}></SecondaryButton>}
            </div>

            { showMessageBox && <MessageBox
                text = {isAddMode ? 'Are you sure cancel?' : 'Are you sure you want to delete expired messages?'}
                yesText = {isAddMode ? 'Cancel' : 'Delete'}
                noText = {isAddMode ? 'No' : 'Cancel'}
                isWarning = {!isAddMode}
                handleClickYes = {() => {
                        if (isAddMode) {
                            if (setIsAddMode) {
                                setIsAddMode(false);
                                setShowMessageBox(false);
                            }
                        } else {
                            deleteExpiredMessages();
                        }
                    }
                }
                handleClickNo = {() => setShowMessageBox(false)}
            />}
		</StyledMessageLeftPane>
    )
}

export default MessageLeftPane;